<template>
<b-card header="Items" header-bg-variant=primary>
  <div class='my-1'/>
  <b-row v-for="item in order.items" :key="getId(item)">
    <b-col cols=* class='pt-2 pr-1'>
      <b-btn small variant=danger>
        <i class='fas fa-times'></i>
      </b-btn>
    </b-col>
    <b-col cols=2 class='pt-2 px-1'>
      <input-merger required :dict=item.sku :disabled="true" />
    </b-col>
    <b-col cols=3 class='pt-2 px-1'>
      <input-merger required :dict=item.description :disabled="true" />
    </b-col>
    <!-- <b-col cols=* class='px-1'>
      <input-merger required checkbox :dict=item.taxable :disabled=disabled>Tax?</input-merger>
      <input-merger required checkbox :dict=item.blank :disabled=disabled>Blank?</input-merger>
    </b-col> -->
    <b-col class='p-0 pt-1 m-0'>
      <b-row class='p-0 m-0'>
        <b-col class='pr-0 pl-1'>
          <input-merger required :dict=item.qty type=number :disabled=disabled @input="calculateTotal(item)">
            <template slot=append>
              <b-input-group-text>
                <span>{{getUom(item)}}.</span>
              </b-input-group-text>
            </template>
          </input-merger>
        </b-col>
        <b-col cols=* class='mt-2 mx-1'>@</b-col>
        <b-col class='px-0 mt-2'>
          <span v-if="!getPriceAdjustment(item)">
            {{getUnitPrice(item) | formatDollars}}
          </span>
          <span v-else>
            {{getUnitPrice(item) | formatDollars}} {{getPriceAdjustment(item) >= 0 ? '+' : '-' }} {{Math.abs(getPriceAdjustment(item)) | formatDollars}}
          </span>
          =
          <strong>{{item.totalPrice.edited | formatDollars}}</strong>
          <!-- <input-merger required :dict=item.unitPrice type=number :disabled=disabled @input="calculateTotal(item)">
            <template slot=prepend>
              <b-input-group-text>
                <span>$</span>
              </b-input-group-text>
            </template>
          </input-merger> -->
        </b-col>
        <b-col cols=*>
          <b-btn small variant=purple @click=editAdjustment(item)>
            <i class='fas fa-edit'></i>
          </b-btn>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
  <b-modal ref=adjustmentModal>

  </b-modal>
</b-card>
</template>

<script>
import orderMerge from '../../../services/orderMerge'
import InputMerger from '../../utility/InputMerger'
import ScreenSizeMixin from '../../../screenSize.js';

export default {
  mixins: [ ScreenSizeMixin ],
  props: {
    order: { type: Object, required: true },
    disabled: { type: Boolean, required: false, default: false },
  },
  watch: {
    breakpoint() {
      console.log(this.breakpoint)
    }
  },
  data() {
    return {
      selectedItem: undefined,
    };
  },
  components: {
    InputMerger,
  },
  mounted() {
    this.order.items.forEach(item => this.calculateTotal(item))
  },
  methods: {
    getId(item) {
      return orderMerge.mergeField(item.id)
    },
    getUnitPrice(item) {
      return orderMerge.mergeField(item.unitPrice)
    },
    getPriceAdjustment(item) {
      return 1
    },
    getUom(item) {
      return orderMerge.mergeField(item.uom.name)
    },
    calculateTotal(item) {
      this.$set(item.totalPrice, 'edited', (this.getUnitPrice(item) + this.getPriceAdjustment(item)) * Number(item.qty['edited']))
    },
    editAdjustment(item) {
      this.selectedItem = item
      this.$refs.adjustmentModal.show()
    }
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/sales-order/edit-order-2/ItemsEditor.vue